import { render, staticRenderFns } from "./base-tab-pane.vue?vue&type=template&id=4f909068"
import script from "./base-tab-pane.vue?vue&type=script&lang=js"
export * from "./base-tab-pane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports